import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProjectDetailsMainComponent } from '@app/components/sections/projects/details/main/main.component';
import { ProjectDetailsInfoMainComponent } from '@app/components/sections/projects/details/info/main/main.component';
import { ProjectDetailsMessagesMainComponent } from '@app/components/sections/projects/details/messages/main/main.component';
import { ProjectDetailsVersionsMainComponent } from '@app/components/sections/projects/details/versions/main/main.component';
import { ProjectAddMainComponent } from '@app/components/sections/projects/add/main/main.component';
import { ProjectPreviewNotesMainComponent } from '@app/components/sections/projects/details/preview-notes/main/main.component';
import { ProjectDetailsVersionDetailsComponent } from '@app/components/sections/projects/details/sections/version/version.component';
import { ProjectDetailsVersionDetailsFilePreviewComponent } from '@app/components/sections/projects/details/sections/version-file-preview/version-file-preview.component';
import { ProjectDetailsVersionAddComponent } from '@app/components/sections/projects/details/sections/version-add/version-add.component';
import { CanLeaveAddProjectGuard } from '@app/components/sections/projects/add/can-leave/can-leave.guard';
import { ProjectDetailsLogbookMainComponent } from 'app/components/sections/projects/details/logbook/main/main.component';
import { ProjectDetailsVersionUploadRequestComponent } from 'app/components/sections/projects/details/sections/version-upload-request/version-upload-request.component';
import { ProjectDetailsFormsMainComponent } from '@app/components/sections/projects/details/custom-forms/main/main.component';
import { canDeactivateFillFormGuard } from '@app/components/sections/projects/details/custom-forms/leave-fill-form/leave-fill-form.guard';

export const projectRoutes: Routes = [
    {
        title: "Add Project",
        path: 'projects/add',
        component: ProjectAddMainComponent,
        canDeactivate: [CanLeaveAddProjectGuard]
    },
    {
        path: 'projects/:id',
        component: ProjectDetailsMainComponent,
        children: [{
                path: '',
                component: ProjectDetailsInfoMainComponent
            },{
                path: 'messages',
                component: ProjectDetailsMessagesMainComponent
            },
            {
                path: 'forms',
                component: ProjectDetailsFormsMainComponent,
                canDeactivate: [canDeactivateFillFormGuard]  // Use the functional guard
            },
            {
                path: 'versions',
                component: ProjectDetailsVersionsMainComponent
            },
            {
                path: 'versions/add',
                component: ProjectDetailsVersionAddComponent
            },
            {
                path: 'files/:fid',
                component: ProjectPreviewNotesMainComponent
            },
            {
                path: 'versions/:vid',
                component: ProjectDetailsVersionDetailsComponent
            },
            {
                path: 'versions/:vid/files/:fid',
                component: ProjectDetailsVersionDetailsFilePreviewComponent
            },
            {
                path: 'logbook',
                component: ProjectDetailsLogbookMainComponent
            },
            {
                path: 'versions/:vid/upload',
                component: ProjectDetailsVersionUploadRequestComponent,
            },


            
        ]
    },
    
];

@NgModule({
    imports: [
        RouterModule.forRoot(projectRoutes)
    ],
    exports: [RouterModule]
})
export class AppProjectsRouterModule { }
